/* unplugin-vue-components disabled */import script from "./ToolbarButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolbarButton.vue?vue&type=script&setup=true&lang=js"

import "./ToolbarButton.vue?vue&type=style&index=0&id=5af30425&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af30425"]])

export default __exports__